export default "/view/img/4a7fdba96ce00f40a0d66e110ebf3ba7.jpg";